import type { RequirementSchema } from '@v2/components/forms/RequirementFieldRenderer';

export type TaskUser = {
    id: number;
    name: string;
    email?: string | null;
    job_title?: string | null;
    department?: string | null;
    avatar_url?: string | null;
};

export type ChecksSummary = {
    containers: number;
    items: number;
};

export type TaskActions = {
    show_hooks: boolean;
    show_po: boolean;
    show_receive_cd: boolean;
    show_check?: boolean;
    show_conference?: boolean;
    conference_url?: string | null;
    show_freight_intake: boolean;
    show_pi_check?: boolean;
    show_protheus_sipo?: boolean;
    can_import_conference_sheet?: boolean;
    conference_url_after_import?: string | null;
    show_customs_translation?: boolean;
    customs_translation_pdf_url?: string | null;
    show_send_customs_email?: boolean;
    po_url: string | null;
    receive_cd_url: string | null;
    check_url?: string | null;
    freight_intake_url: string | null;
    pi_check_url?: string | null;
    protheus_sipo_url?: string | null;
};

export type ShipmentTaskRow = {
    id: number;
    shipment_id: number;
    stage: string;
    stage_label: string;
    stage_color: string;
    stage_row_color: string | null;
    title: string;
    description: string | null;
    responsible: string | null;
    assigned_to: number | null;
    assigned_user: TaskUser | null;
    completed_by_user: TaskUser | null;
    is_completed: boolean;
    sla_days?: number | null;
    due_date?: string | null;
    sla_business_days?: boolean;
    sla_start_label?: string | null;
    sla_status?: { state: 'overdue' | 'due_today' | 'due_soon' | 'on_time' | 'waiting' | 'done_on_time' | 'done_late'; label: string; days: number } | null;
    completed_at: string | null;
    is_auto: boolean;
    sort_order?: number;
    requirements?: unknown;
    requirements_schema?: RequirementSchema[];
    requirement_data?: Record<string, unknown>;
    requirement_defaults?: Record<string, unknown>;
    has_requirements?: boolean;
    hooks_guide?: string | null;
    resolved_hooks_guide?: string | null;
    resolved_hooks_guide_html?: string | null;
    notes?: string | null;
    comments_count?: number;
    checks_summary?: ChecksSummary;
    actions: TaskActions;
};

export type ShipmentContainerRow = {
    id: number;
    shipment_id: number;
    container_number: string;
    type?: string | null;
    seal_number?: string | null;
    cbm?: string | number | null;
    cbm_capacity?: number | null;
    observations?: string | null;
};

export type TaskComment = {
    id: number;
    parent_id: number | null;
    body: string;
    created_at: string | null;
    author: { id: number; name: string } | null;
    replies?: TaskComment[];
};

export type TaskFormPayload = {
    stage: string;
    title: string;
    description?: string;
    responsible?: string;
    assigned_to?: number | null;
    notes?: string;
    hooks_guide?: string;
};

export const SHIPMENT_STAGES = [
    'pedido',
    'validacao',
    'financeiro',
    'producao',
    'financeiro2',
    'embarque',
    'transito',
    'desembaraco',
    'fiscal',
    'entrega',
    'concluido',
] as const;
